// Icons/UserIcon.jsx
export default function UserIcon({
  className = "",
  size = 20,   // px
  color,       // optional; otherwise use Tailwind text-* via className
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={size}
      height={size}
      fill={color || "currentColor"}
      className={className}
      style={color ? { color, ...(rest.style || {}) } : rest.style}
      aria-hidden="true"
      {...rest}
    >
      {/* Font Awesome Free v7.1.0 */}
      <path d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z"/>
    </svg>
  );
}
